import { useShallow } from "zustand/react/shallow";

import { useRouteModalsStore } from "../route-modals.store";
import { useUserTriggeredModalsStore } from "../user-triggered-modals.store";

export const useModalBgClickDismiss = () => {
  const isRouteModalBackgroundDismissable = useRouteModalsStore((state) => state.behaviorOptions?.closeOnBgClick ?? true);
  const openTriggeredModalIds = useUserTriggeredModalsStore((state) => state.openIds);

  const dismissableTriggeredModalIds = useUserTriggeredModalsStore(
    useShallow((state) => state.openIds.filter((id) => state.behaviorOptions[id]?.closeOnBgClick ?? true)),
  );

  const canDismissWithBackgroundClick = () => {
    if (openTriggeredModalIds.length === 0) {
      return isRouteModalBackgroundDismissable;
    }

    const topmostModalId = openTriggeredModalIds[openTriggeredModalIds.length - 1]!;

    return dismissableTriggeredModalIds.includes(topmostModalId);
  };

  return { canDismissWithBackgroundClick };
};
